import { apiConfig } from '../../config';

import { APIService } from './API';

const apiService = new APIService(apiConfig.serverURLs.settings);

export const getPublicSettingsValues = async (key: string): Promise<string> => {
    const response = await apiService.get<{ value: string }>(
        `v1/public/values/${key}`
    );
    return response?.data?.value;
};
